import { memo } from 'react';
import clsx from 'clsx';
import { useOtherSettings } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import GamesList from '../../common/GamesList';
import GamesSectionHeader from '../../common/GamesSectionHeader';
import {
  ROWS_WITH_GAMES,
  SEARCH_RECOMMENDED_CATEGORY_GAMES_LIST_ID
} from '../../constants';
import { useExcludedActiveBonusGamesList } from '../../store';
import { gamesPlaceholder } from '../../utils';
import { useGameListCommonProps } from './useGameListCommonProps';
import { useRecommendedGamesCasinoSearch } from './useRecommendedGamesCasinoSearch';

import styles from './index.module.css';

const RecommendedGamesOnCasinoSearch = ({
  gamesListKind = ROWS_WITH_GAMES.ALL_WITHOUT_PAGINATION,
  classNames = {}
}) => {
  const { recommendedHeaderDesktop = '', searchGameSectionTitle = '' } =
    classNames;
  const { isGameCardsMinimisedConfig = false } = useOtherSettings();
  const { isDesktop } = useDeviceStore();

  const gameListCommonProps = useGameListCommonProps();
  const recommendedCategory = useRecommendedGamesCasinoSearch();

  const { excludedBonusGamesList } = useExcludedActiveBonusGamesList();

  return recommendedCategory ? (
    <div
      className={clsx([
        styles.resultsWrapper,
        isGameCardsMinimisedConfig &&
          !isDesktop &&
          styles.resultsWrapperMinimised
      ])}
    >
      <GamesSectionHeader
        title={recommendedCategory.title}
        className={clsx([styles.recommendedHeader, recommendedHeaderDesktop])}
        classNames={{
          searchGameSectionTitle
        }}
      />
      <GamesList
        games={
          recommendedCategory.isCategoryLoading
            ? gamesPlaceholder
            : recommendedCategory.categoryGames
        }
        excludedBonusGamesList={excludedBonusGamesList}
        kind={gamesListKind}
        id={SEARCH_RECOMMENDED_CATEGORY_GAMES_LIST_ID}
        classNames={{ searchGamesList: styles.searchGamesList }}
        {...gameListCommonProps}
      />
    </div>
  ) : null;
};

export default memo(RecommendedGamesOnCasinoSearch);
